import { render, staticRenderFns } from "./MyPurchasesPage.vue?vue&type=template&id=9da3178e&scoped=true&"
import script from "./MyPurchasesPage.vue?vue&type=script&lang=ts&"
export * from "./MyPurchasesPage.vue?vue&type=script&lang=ts&"
import style0 from "./MyPurchasesPage.vue?vue&type=style&index=0&id=9da3178e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da3178e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon,VPagination,VSelect})
